export default {
	EVENTNUMBEROFDAYS: 'eventnumberofdays',
	DAILYOILRATIOS: 'dailyOilRatios',
	OILRATIO: 'oilRatio',
}


// WEBPACK FOOTER //
// ./src/containers/event/components/laneConditions/fields.js